
<template>

  <svg viewBox="0 0 116.3 65.67" aria-hidden="true">

    <path d="m86.28 47.47c-0.27-6.13 6.72-11.33 10.84-15.66s11.11-9.53 10.84-15.66c-0.4-8.9-13.19-13.25-23.08-16.15h-30.21c8.19 4.29 12.45 7.83 5.58 16.15-5.82 7.04-19.81 11.63-28.41 15.66s-22.59 8.62-28.41 15.66c-7.93 9.6-1.03 12.84 9.6 18.2h103.27c-9.22-2.97-29.52-6.94-30.02-18.2m-11.5-45.95c2.32 1.42 4.17 2.81 5.61 4.15h-1.74c-1.38-1.34-3.16-2.72-5.41-4.15h1.54zm-22.09 36.78h3.66c-3.96 2.94-7.1 5.95-8.28 9.14h-4.18c1.33-3.2 4.64-6.21 8.8-9.14m0.65 24.16c-7.26-4.38-10.11-8.34-10.09-12.03h4.32c0.14 3.7 3.16 7.66 10.64 12.03h-4.87zm6.21-26.42v-0.27h-3.09c3.32-2.11 6.9-4.2 10.33-6.31h3.01c-3.4 2.21-6.98 4.38-10.25 6.58m12.66-8.14h-2.9c2.75-1.76 5.32-3.54 7.44-5.36h2.54c-2.01 1.82-4.45 3.6-7.08 5.36m8.69-6.94h-2.44c1.83-1.83 3.16-3.72 3.74-5.67h2.16c-0.5 1.95-1.73 3.83-3.46 5.67m3.66-6.93h-2.1c0.29-2.39-0.57-4.9-3.03-7.56h1.78c2.56 2.65 3.54 5.16 3.35 7.56" clip-path="url(#SVGID_00000129199929350515776800000001395869075299895464_)"
    
      fill="currentColor" />

  </svg>

</template>
